<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-costs page-operative-data-analysis-costs-edit">
    <div class="container">
      <PageTitle>Modifica costo di struttura</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Costo di struttura da modificare non trovato</div>
      <FormCostoGA v-else-if="company && userCanEdit" :costo.sync="costo" edit @saved="saveCosto" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-costs-ga-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormCostoGA: () => import('../../../../components/Operative/Form/FormCostoGA'),
  },
  data () {
    return {
      costo: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveCosto (costo) {
      this.$api.updateCostoGA(this.company.id, costo.id, costo)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.ga',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getCostoGA(this.company.id, this.$route.params.costId)
          .then(res => {
            this.costo = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
